export default __webpack_public_path__ + "media/images/close_nav-d0bed505201b525a1ef7c6b355690f04.svg";